import React, {useEffect, useState} from 'react'
import firebaseMenuMaker from '../../firebase-menumaker'

export default function useSyncSnapshotMenu (path) {
  const [globalSnapshot, setSnapshot] = useState(null)
  useEffect(function sync() {
    const ref = firebaseMenuMaker.database().ref(path)
    ref.on('value', function (snapshot) {
      setSnapshot(snapshot)
    })

    return(() => ref.off())
  }, [path])

  return globalSnapshot
}
